import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { Tabs } from '@shopify/polaris';
import Debug from './Debug';
import Codes from './Codes';
import Users from './Users';
import Customers from './Customers';
import AdjustToken from './AdjustToken';
import Home from './Home';

const tabs = [
  { id: 'home', content: 'Home', accessibilityLabel: 'Home', path: '/' },
  { id: 'new-codes', content: 'New Codes', accessibilityLabel: 'New Codes', path: '/new-codes' },
  { id: 'used-codes', content: 'Used Codes', accessibilityLabel: 'Used Codes', path: '/used-codes' },
  { id: 'users', content: 'Users', accessibilityLabel: 'Users', path: '/users' },
  { id: 'customers', content: 'Customers', accessibilityLabel: 'Customers', path: '/customers' },
  { id: 'adjust-token', content: 'Adjust Tokens', accessibilityLabel: 'Adjust Tokens', path: '/adjust-token' },
  { id: 'debug', content: 'Debug', accessibilityLabel: 'Debug', path: '/debug' },
];

function getSelectedIndex(pathname) {
  if (pathname.indexOf('/new-codes') === 0) return 1;
  if (pathname.indexOf('/used-codes') === 0) return 2;
  if (pathname.indexOf('/users') === 0) return 3;
  if (pathname.indexOf('/customers') === 0) return 4;
  if (pathname.indexOf('/adjust-token') === 0) return 5;
  if (pathname.indexOf('/debug') === 0) return 6;
  return 0;
}

function AppContent() {
  const history = useHistory();
  const location = useLocation();
  const [selected, setSelected] = useState(getSelectedIndex(location.pathname));

  const handleTabChange = useCallback(selectedTabIndex => {
    setSelected(selectedTabIndex);
    history.push(tabs[selectedTabIndex].path);
  }, [history]);

  return (
    <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
      <Switch>
        <Route path="/new-codes">
          <Codes status="unused" />
        </Route>
        <Route path="/used-codes">
          <Codes status="used" />
        </Route>
        <Route path="/users">
          <Users />
        </Route>
        <Route path="/customers">
          <Customers />
        </Route>
        <Route path="/adjust-token">
          <AdjustToken />
        </Route>
        <Route path="/debug">
          <Debug />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Tabs>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
